import { render, staticRenderFns } from "./PaySlipView.vue?vue&type=template&id=1cdacfd2&scoped=true&"
import script from "./PaySlipView.vue?vue&type=script&lang=js&"
export * from "./PaySlipView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdacfd2",
  null
  
)

export default component.exports